import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import callApi from "src/services/Common/api";
import { useSetRecoilState } from "recoil";
import { alertMessageState } from "src/atom/LoadingState";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const MilestoneChart = () => {
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const [data, setData] = useState(null);

  const fetchBarDataApiCall = async () => {
    try {
      const response = await callApi(
        "/v1/api/getPostCategoryCount",
        "GET",
        null,
        true,
        setAlertMessage
      );
      if (response.success !== false) {
        setData(response.body);
      } else {
        setAlertMessage({ type: "error", message: "Failed to load data" });
      }
    } catch (error) {
      setAlertMessage({ type: "error", message: "API call failed" });
    }
  };

  useEffect(() => {
    fetchBarDataApiCall();
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  const chandigarhData = data.filter((item) => item.label2 === "CHANDIGARH");
  const newDelhiData = data.filter((item) => item.label2 === "NEW DELHI");
  const chandigarhCounts = chandigarhData.map((item) => parseInt(item.count));
  const newDelhiCounts = newDelhiData.map((item) => parseInt(item.count));
  const combinedLabels = ["AAG", "DAG", "SDAG", "ADAG"];

  const chartData = {
    labels: combinedLabels,
    datasets: [
      {
        label: "Chandigarh",
        data: chandigarhCounts,
        backgroundColor: "rgba(75, 192, 192, 0.5)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "New Delhi",
        data: newDelhiCounts,
        backgroundColor: "rgba(153, 102, 255, 0.5)",
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Advocates Data for Chandigarh and New Delhi",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Role",
        },
      },
      y: {
        title: {
          display: true,
          text: "Count",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <>
      <div className="mt-2">
        <Bar
          data={chartData}
          options={options}
          style={{
            display: "block",
            boxSizing: "border-box",
            height: "300px",
            width: "550px",
          }}
        />
      </div>
      <div className="ms-5 mb-3">
        <span style={{ display: "block" }}>
          <b>AAG</b>:- Assistant Advocate General
        </span>
        <span style={{ display: "block" }}>
          <b>DAG</b>:- Deputy Advocate General
        </span>
        <span style={{ display: "block" }}>
          <b>SDAG</b>:- Senior Deputy Advocate General
        </span>
        <span style={{ display: "block" }}>
          <b>ADAG</b>:- Additional Advocate General
        </span>
      </div>
    </>
  );
};

export default MilestoneChart;
